"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const dayjs_1 = __importDefault(require("dayjs"));
const displayFormatOptions = {
    de: {
        date: 'DD.MM.YYYY',
        time: 'HH:mm',
        datetime: 'DD.MM.YYYY HH:mm'
    },
    en: {
        date: 'DD/MM/YYYY',
        time: 'HH:mm',
        datetime: 'DD/MM/YYYY HH:mm'
    }
};
const toLocaleDatePlugin = (_options, dayjsClass) => {
    const METHOD_NAME_PREFIX = 'toLocale';
    const methodNames = ['toLocaleTime', 'toLocaleDate', 'toLocaleDateTime'];
    methodNames.forEach((methodName) => {
        dayjsClass.prototype[methodName] = function () {
            const locale = this.locale();
            const format = methodName.replace(METHOD_NAME_PREFIX, '').toLowerCase();
            return this.format(displayFormatOptions[locale][format]);
        };
    });
};
dayjs_1.default.extend(toLocaleDatePlugin);
